import React from 'react';

function AboutCreator() {
  return (
    <section id="about" className="bg-gray-100 py-12 px-6 rounded-lg shadow-md max-w-4xl mx-auto text-center mt-12">
      <h2 className='text-yellow-500 text-2xl font-bold mb-6'>Created by a Visionary Leader</h2>
      <p className="text-gray-800 text-lg leading-relaxed">
        Crafted by a seasoned entrepreneur with over <span className="font-semibold">30 years of experience</span>, including leading an
        e-commerce transformation to a <span className="font-semibold">$500M valuation</span>. A <span className="font-semibold">Six Sigma Black Belt</span>
        with expertise in operations, finance, and digital marketing.
      </p>
      <div className="mt-6 flex justify-center">
        <button className="bg-yellow-500 text-white px-6 py-3 rounded-lg shadow hover:bg-yellow-600 transition text-lg font-medium">
          Learn More
        </button>
      </div>
    </section>
  );
}

export default AboutCreator;